import styled from 'styled-components';
import { prop } from 'styled-tools';

export default styled.div<{ width: string; height: string }>`
  width: 120px;
  height: 120px;
  flex: 0 0 120px;
  margin-right: 16px;
  background: white;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: ${prop('width')};
    height: ${prop('height')};
  }
`;
